import { connect } from 'react-redux';
import ResetPassword from '../../components/ResetPassword';

import {
  updatePasswordRequest
} from '@xanadu/ui-shared/modules/resetPassword/actions';

import {
  loginRequest,
} from '@xanadu/ui-shared/modules/userSession/actions';

const mapDispatchToProps = {
  updatePasswordRequest,
  loginRequest
};

function mapStateToProps(state) {
  return {
    loading: state.getIn(['resetPassword', 'loading']),
    success: state.getIn(['resetPassword', 'success']),
    error: state.getIn(['resetPassword', 'error']),
    params: state.getIn(['resetPassword', 'params']),
    widthSize: state.getIn(['application', 'widthSize']),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
